import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { PositionType, SpaceType } from 'data/types';
import { geometryFromAbsolutePolygon } from 'utils/carve-auto-layout-space';
import {
  commitMovedSpaceGeometry,
  RemainderSyncState
} from 'utils/leftover-space-sync';
import { beginUndoBatch, endUndoBatch } from './structure-history-middleware';
import { deleteStructureItem } from './structure-slice';
import { addNewSpaceToLevel } from './structure-thunks';

type AddDrawnSpaceToLevelArgs = {
  levelId: string;
  spaceItemId: number;
  vertices: PositionType[];
};

function remainderSyncStateFromRootState(state: RootState): RemainderSyncState {
  return {
    structure: state.structure.structure,
    autoLayoutSpaceIds: state.structure.autoLayoutSpaceIds,
    catalogAttributes: state.data.attributes,
    footprint: state.structure.footprint
  };
}

export const addDrawnSpaceToLevel = createAsyncThunk<
  SpaceType | null,
  AddDrawnSpaceToLevelArgs
>(
  'structure/addDrawnSpaceToLevel',
  async ({ levelId, spaceItemId, vertices }, { getState, dispatch }) => {
    const geometry = geometryFromAbsolutePolygon(vertices);
    if (!geometry) {
      return null;
    }

    const newSpace = await dispatch(
      addNewSpaceToLevel({ levelId, spaceItemId })
    ).unwrap();
    if (!newSpace) {
      return null;
    }

    dispatch(beginUndoBatch());
    const placed = commitMovedSpaceGeometry(
      dispatch,
      newSpace.uniqueId,
      geometry,
      geometry.squareFootage,
      remainderSyncStateFromRootState(getState() as RootState)
    );
    if (!placed) {
      dispatch(deleteStructureItem({ uniqueId: newSpace.uniqueId }));
    }
    dispatch(endUndoBatch());

    return placed ? newSpace : null;
  }
);
